module.exports = __webpack_public_path__ + "assets/e8a6f4c2656e49fdb08d09c760c649fa.mp4";